import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ClickAnalyticsPlugin } from "@microsoft/applicationinsights-clickanalytics-js";
import { CONFIG } from "../../config-global";
// import customHistory from "../../layout/custom-history";

const reactPlugin = new ReactPlugin();
const { connectionString, instrumentationKey } = CONFIG.appInsights;

// Click Analytics configuration
const clickPluginInstance = new ClickAnalyticsPlugin();
const clickPluginConfig = {
  autoCapture: true,
};

// Application Insights Configuration
const ai = new ApplicationInsights({
  config: {
    connectionString,
    instrumentationKey,
    extensions: [reactPlugin, clickPluginInstance],
    enableAutoRouteTracking: true,
    autoTrackPageVisitTime: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    extensionConfig: {
      [clickPluginInstance.identifier]: { clickPluginConfig },
    },
  },
});

if (instrumentationKey || connectionString) {
  ai.loadAppInsights();
  ai.trackPageView();
}

export const { appInsights } = ai;
export { reactPlugin };
